import { render, staticRenderFns } from "./EditorImageUpload.vue?vue&type=template&id=6bc6c1e2&scoped=true&lang=pug&"
import script from "./EditorImageUpload.vue?vue&type=script&lang=js&"
export * from "./EditorImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./EditorImageUpload.vue?vue&type=style&index=0&id=6bc6c1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6c1e2",
  null
  
)

export default component.exports